import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import '../../../../../../util/styles/index.js';
import { createDebouncedFunction } from '../../../../../../util/useDebounce.js';
import '../../../hooks/useEmblaCarousel.js';
import { CAROUSEL_CONSTANTS } from '../constants.js';
import { findPageIndexByCardIndex, toggleAriaSlideAttrs } from '../helpers.js';
import useEmblaCarousel from 'embla-carousel-react';
import { useAdsStyles } from '../../../../../../util/styles/hooks/useAdsStyles.js';

var _excluded = ["gap", "pageButtons", "pageControl", "currentCard", "onPageChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useRoot = function useRoot(props) {
  var gap = props.gap,
    pageButtons = props.pageButtons,
    pageControl = props.pageControl,
    currentCard = props.currentCard,
    onPageChange = props.onPageChange,
    restProps = _objectWithoutProperties(props, _excluded);
  var _useEmblaCarousel = useEmblaCarousel({
      inViewThreshold: CAROUSEL_CONSTANTS.IN_VIEW_THRESHOLD,
      slidesToScroll: 'auto',
      axis: 'x'
    }),
    _useEmblaCarousel2 = _slicedToArray(_useEmblaCarousel, 2),
    carouselRef = _useEmblaCarousel2[0],
    carouselApi = _useEmblaCarousel2[1];
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    canScrollPrev = _React$useState2[0],
    setCanScrollPrev = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    canScrollNext = _React$useState4[0],
    setCanScrollNext = _React$useState4[1];
  var onSelect = React.useCallback(function (event) {
    if (!event) {
      return;
    }
    setCanScrollPrev(event.canScrollPrev());
    setCanScrollNext(event.canScrollNext());

    // currently scrollLeft and scrollDirection are not supported
    onPageChange === null || onPageChange === void 0 || onPageChange(event.selectedScrollSnap(), event.slideNodes().length, 0, 'next');
  }, [onPageChange]);
  var scrollPrev = React.useCallback(function () {
    carouselApi === null || carouselApi === void 0 || carouselApi.scrollPrev();
  }, [carouselApi]);
  var scrollNext = React.useCallback(function () {
    carouselApi === null || carouselApi === void 0 || carouselApi.scrollNext();
  }, [carouselApi]);
  var handleKeyDown = React.useCallback(function (event) {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      scrollPrev();
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      scrollNext();
    }
  }, [scrollPrev, scrollNext]);
  React.useEffect(function () {
    if (typeof currentCard === 'number' && carouselApi) {
      var engine = carouselApi.internalEngine();
      var groupedSlides = engine.slidesToScroll.groupSlides(carouselApi.slideNodes());
      var targetPageIndex = findPageIndexByCardIndex(groupedSlides, currentCard);
      carouselApi.scrollTo(targetPageIndex, true);
    }
  }, [carouselApi, currentCard]);
  React.useEffect(function () {
    if (!carouselApi) {
      return undefined;
    }
    onSelect(carouselApi);
    carouselApi.on('reInit', onSelect);
    carouselApi.on('select', onSelect);
    var debouncedToggleAriaSlideAttrs = createDebouncedFunction(function () {
      return toggleAriaSlideAttrs(carouselApi);
    }, CAROUSEL_CONSTANTS.ARIA_UPDATE_DEBOUNCE_DELAY);
    carouselApi.on('slidesInView', debouncedToggleAriaSlideAttrs);
    return function () {
      carouselApi === null || carouselApi === void 0 || carouselApi.off('select', onSelect);
      carouselApi === null || carouselApi === void 0 || carouselApi.off('reInit', onSelect);
      carouselApi === null || carouselApi === void 0 || carouselApi.off('slidesInView', debouncedToggleAriaSlideAttrs);
    };
  }, [carouselApi, onSelect]);
  var contextValue = {
    carouselRef: carouselRef,
    carouselApi: carouselApi,
    scrollPrev: scrollPrev,
    scrollNext: scrollNext,
    canScrollPrev: canScrollPrev,
    canScrollNext: canScrollNext,
    gap: gap,
    pageButtons: pageButtons,
    pageControl: pageControl
  };
  var _useAdsStyles = useAdsStyles(),
    mapAdsStyles = _useAdsStyles.mapAdsStyles;
  var rootStyles = mapAdsStyles({
    position: 'relative',
    width: '100%'
  });
  var rootProps = _objectSpread(_objectSpread({
    onKeyDownCapture: handleKeyDown
  }, rootStyles), restProps);
  return {
    contextValue: contextValue,
    rootProps: rootProps
  };
};

export { useRoot };
//# sourceMappingURL=useRoot.js.map
